export default "__VITE_ASSET__vYLwQnp5__"